import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { IoSend } from 'react-icons/io5';

const ContactForm = () => {
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = () => {
    setIsSubmitting(true);
  };

  return (
    <motion.form
      onSubmit={handleSubmit}
      action="https://formsubmit.co/80d2ad5480cf9f09fc9213944f62a201"
      method="POST"
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6 }}
      className="space-y-6"
    >
      {/* Hidden FormSubmit configuration */}
      <input type="hidden" name="_captcha" value="false" />
      <input type="hidden" name="_next" value="https://rayyanshaheer.github.io/thank-you.html" />
      <input type="hidden" name="_subject" value="New Portfolio Contact Form Submission" />
      <input type="hidden" name="_autoresponse" value="Thank you for your message! I'll get back to you soon." />

      {/* Name Field */}
      <div>
        <label htmlFor="name" className="block text-white-1 font-medium mb-2 text-sm">
          Full Name *
        </label>
        <input
          type="text"
          id="name"
          name="name"
          required
          className="w-full px-4 py-3 bg-white-1/5 border border-white-1/10 rounded-lg text-white-1 placeholder-light-gray/50 focus:outline-none focus:border-accent-yellow/50 focus:ring-1 focus:ring-accent-yellow/20 transition-all duration-300"
          placeholder="Enter your full name"
        />
      </div>

      {/* Email Field */}
      <div>
        <label htmlFor="email" className="block text-white-1 font-medium mb-2 text-sm">
          Email Address *
        </label>
        <input
          type="email"
          id="email"
          name="email"
          required
          className="w-full px-4 py-3 bg-white-1/5 border border-white-1/10 rounded-lg text-white-1 placeholder-light-gray/50 focus:outline-none focus:border-accent-yellow/50 focus:ring-1 focus:ring-accent-yellow/20 transition-all duration-300"
          placeholder="Enter your email address"
        />
      </div>

      {/* Message Field */}
      <div>
        <label htmlFor="message" className="block text-white-1 font-medium mb-2 text-sm">
          Message *
        </label>
        <textarea
          id="message"
          name="message"
          required
          rows={5}
          className="w-full px-4 py-3 bg-white-1/5 border border-white-1/10 rounded-lg text-white-1 placeholder-light-gray/50 focus:outline-none focus:border-accent-yellow/50 focus:ring-1 focus:ring-accent-yellow/20 transition-all duration-300 resize-vertical"
          placeholder="Tell me about your project or inquiry..."
        />
      </div>

      {/* Submit Button */}
      <motion.button
        type="submit"
        disabled={isSubmitting}
        whileHover={!isSubmitting ? { scale: 1.02 } : {}}
        whileTap={!isSubmitting ? { scale: 0.98 } : {}}
        className={`w-full flex items-center justify-center gap-3 px-6 py-3 font-medium rounded-lg transition-all duration-300 ${
          isSubmitting
            ? 'bg-white-1/10 text-light-gray/50 cursor-not-allowed'
            : 'bg-accent-yellow text-bg-dark hover:bg-accent-yellow/90'
        }`}
      >
        {isSubmitting ? (
          <>
            <div className="w-4 h-4 border-2 border-light-gray/50 border-t-transparent rounded-full animate-spin"></div>
            Sending...
          </>
        ) : (
          <>
            <IoSend size={18} />
            Send Message
          </>
        )}
      </motion.button>

      <p className="text-light-gray/60 text-xs text-center">
        I typically respond within 24 hours during business days.
      </p>
    </motion.form>
  );
};

export default ContactForm;
